export default "__VITE_ASSET__de20a900__"